<template>
  <span
    class="llm-delete-icon-btn"
    :class="`llm-delete-icon-btn--${size}`"
    :title="title"
    role="button"
    tabindex="0"
    v-on="$listeners"
  >
    <Icon type="ios-trash-outline" :size="iconSize" />
  </span>
</template>

<script>
const ICON_SIZE_MAP = {
  sm: 16,
  md: 20,
}

export default {
  name: 'DeleteIconButton',
  props: {
    title: {
      type: String,
      default: '删除',
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md'].includes(v),
    },
  },
  computed: {
    iconSize() {
      return ICON_SIZE_MAP[this.size] || ICON_SIZE_MAP.md
    },
  },
}
</script>

<style scoped>
.llm-delete-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  color: #909399;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  outline: none;
  vertical-align: middle;
  line-height: 1;
}

.llm-delete-icon-btn--sm {
  width: 20px;
  height: 20px;
}

.llm-delete-icon-btn--md {
  width: 32px;
  height: 32px;
}

.llm-delete-icon-btn:hover,
.llm-delete-icon-btn:focus-visible {
  background: #ffecec;
  color: #ed4014;
}

.llm-delete-icon-btn ::v-deep .ivu-icon {
  line-height: 1;
}
</style>
